<template>
  <div class="container lms-wrapper">
    
    <student-nav />

    <div class="lms-content" @click="closeLevel2()">
      <student-header :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Onboarding хөтөлбөр</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Дашбоард</li>
              </ol>
            </nav>
          </div>

              

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>




    
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  components: {
    vueCustomScrollbar,
    
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      welcomes:[
        {id: 1, title: 'Голомт банкны тухай', img: '', color: '',  cols: 6, h: 280, bg: 'linear-gradient(135.15deg, #33B7FF 2.15%, #17A0E2 65.39%, #17A0E2 98.4%)',
          bgimg: 'apps/golomt/bg-buddy-1.png'
         },
        {id: 2, title: 'Голомтын соёл, гоёл', img: '', color: '', cols: 6, h: 280, bg: 'linear-gradient(135.15deg, #3AC37A 2.15%, #33BF75 65.39%, #55EB9B 98.4%)',
          bgimg: 'apps/golomt/bg-buddy-2.png'
         },
        { id: 3, title: 'Хөнгөлөлт, хангамж', img: '', color: '', cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #9C14F2 2.15%, #9627DD 65.39%, #B255EC 98.4%)',
          bgimg: 'apps/golomt/bg-buddy-3.png'
         },
        {id: 4, title: 'Хөтөлбөр', img: '', color: '', cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%);' ,
          bgimg: 'apps/golomt/bg-buddy-4.png'
        },
        { id: 5, title: 'Тоглох уу', img: '', color: '', cols: 4, h: 350, bg: 'linear-gradient(135.15deg, #34BDBD 2.15%, #12A0A1 65.39%, #37BABC 98.4%);' ,
          bgimg: 'apps/golomt/bg-buddy-5.png'
        },
      ],
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    gotoW(n) {
      // console.log('n', n);
      switch(n.id){
        case 1: 
          window.open('https://golomtbank.com', '_blank');
          break;
        case 2: 
          this.$router.push({name: 'buddyCulture', params: { id: 0} })
          break;
        case 3: 
          this.$router.push({name: 'buddyVoucher', params: { id: 0} })
          break;
        case 4: 
          this.$router.push({name: 'buddyEvent', params: { id: 0} })
          break;
        case 5: 
          this.$router.push({name: 'buddyQuiz' })
          break;
        default: break;
      }
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init() {
    },
    
  },
};
</script>